import { render, staticRenderFns } from "./OldReport.vue?vue&type=template&id=bbc9b590&scoped=true&"
import script from "./OldReport.vue?vue&type=script&lang=js&"
export * from "./OldReport.vue?vue&type=script&lang=js&"
import style0 from "./OldReport.vue?vue&type=style&index=0&id=bbc9b590&lang=scss&scoped=true&"
import style1 from "./OldReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc9b590",
  null
  
)

export default component.exports